import React from "react";
import AdminSale from "../components/AdminSale";
import useAdminSale from "../hooks/useAdminSale";

const AdminSaleInterface = (props) => {
  const {
    superUser,
    saleId,
    saleCreated,
    productName,
    productType,
    onProductTypeChange,
    saleStatus,
    onStatusChange,
    saleNote,
    onNoteChange,
    productId,
    onProductIdChange,
    saleCurrency,
    onCurrencyChange,
    saleAmount,
    onAmountChange,
    saleNb,
    onNbChange,
    saleRefNumber,
    onRefnumberChange,
    salePaymentMethodName,
    onChangePaymentMethodName,
    salePaymentMethod,
    onPaymentMethodChange,
    saleNotif,
    onSaleNotifChange,
    saleUppTransactionNumber,
    onChangeSaleUppTransactionNumber,
    saleReferer,
    onRefererChange,
    submitting,
    handlePostItem,
    onProductNameChange,
    userEmail,
    stripeData,
    stripeLoading,
    stripeError,
    onStripeSearch,
  } = useAdminSale(props);

  const { onCancelAction, canEdit } = props;

  return (
    <AdminSale
      canEdit={canEdit}
      superUser={superUser}
      saleId={saleId}
      created={saleCreated}
      productName={productName}
      productType={productType}
      onProductTypeChange={onProductTypeChange}
      status={saleStatus}
      onStatusChange={onStatusChange}
      saleNote={saleNote}
      onNoteChange={onNoteChange}
      productId={productId}
      onProductIdChange={onProductIdChange}
      currency={saleCurrency}
      onCurrencyChange={onCurrencyChange}
      amount={saleAmount}
      onAmountChange={onAmountChange}
      saleNb={saleNb}
      onNbChange={onNbChange}
      refnumber={saleRefNumber}
      onRefnumberChange={onRefnumberChange}
      paymentMethodName={salePaymentMethodName}
      onChangePaymentMethodName={onChangePaymentMethodName}
      paymentMethod={salePaymentMethod}
      onPaymentMethodChange={onPaymentMethodChange}
      saleNotif={saleNotif}
      onSaleNotifChange={onSaleNotifChange}
      saleUppTransactionNumber={saleUppTransactionNumber}
      onChangeSaleUppTransactionNumber={onChangeSaleUppTransactionNumber}
      referer={saleReferer}
      onRefererChange={onRefererChange}
      submitting={submitting}
      handlePostItem={handlePostItem}
      onProductNameChange={onProductNameChange}
      onCancelAction={onCancelAction}
      userEmail={userEmail}
      stripeData={stripeData}
      stripeLoading={stripeLoading}
      stripeError={stripeError}
      onStripeSearch={onStripeSearch}
    />
  );
};

export default AdminSaleInterface;
